import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import DraggableModal from 'components/organisms/draggableModal';
import { useRpmPatientActivity } from 'infrastructure/hooks/rpm';
import ReadingCell from 'components/molecules/rpm-overview-table/components/reading-table/reading-cell';
import BaseLoader from 'components/atoms/base-loader';
import DateCell from 'components/molecules/rpm-overview-table/components/reading-table/date-cell';
import { convertDateToTimeZone } from 'infrastructure/functions';

import s from './styles.module.scss';

import type { IActivityData } from 'infrastructure/interfaces/i-rpm-patient-activity';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  patientGuid: string;
  recoveredByReadingId: string;
};

const getReadingDate = (reading: IActivityData) => {
  return new Date(parseInt(reading.createdAt));
};

const getPatientReadingDate = (reading: IActivityData) => {
  return convertDateToTimeZone(
    getReadingDate(reading),
    reading.patient.timezone,
  );
};

const RecoveredStatusModal: FC<Props> = ({
  isOpen,
  onClose,
  patientGuid,
  recoveredByReadingId,
}) => {
  const { t } = useTranslation();

  const { activity, isLoading } = useRpmPatientActivity({
    readingId: recoveredByReadingId,
    meta: { items: 1, page: 0 },
    patientGuid,
  });

  const reading = activity?.data?.[0];

  return (
    <>
      <DraggableModal
        title={t('labels.recoveredByReading')}
        isOpen={isOpen}
        toggle={onClose}
        bodyClassName={s['modal-body']}
        modalClassName={s.modal}
        footerClassName={s['modal-footer']}
      >
        <div className={s.wrapper}>
          <BaseLoader loading={isLoading} />
          {reading && (
            <div className={s.content}>
              <div>
                <p>{t('labels.readingTime')}:</p>
                <DateCell date={getReadingDate(reading)} />
              </div>
              <div className={s.divider} />
              <div>
                <p>{t('labels.patientTime')}:</p>
                <DateCell date={getPatientReadingDate(reading)} />
              </div>
              <div className={s.divider} />
              <div>
                <p>{t('labels.reading')}:</p>
                <ReadingCell
                  values={reading.value}
                  statuses={reading.statuses}
                  readingType={reading.readingType}
                />
              </div>
            </div>
          )}
        </div>
      </DraggableModal>
    </>
  );
};

export default RecoveredStatusModal;
